import React from "react"
import Navbar from "../../Common/Components/Navbar"
import Footer from "../../Common/Components/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import HelpComp from "./Component/HelpComp"


const Help =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <HelpComp />
        </div>
        <Footer />
        </>
    )
}

export default Help